<template>
  <div class="side-panel">
    <div class="panel">
      <div class="panel-header">
        <h1>
          Sort &amp; Filter
          <span class="count" v-if="count">{{ count }} Results</span>
        </h1>
        <div class="close" @click.stop="close">
          <ag-icon width="32" height="32">
            <x-icon />
          </ag-icon>
        </div>
      </div>
      <div class="panel-content">
        <ag-form-group id="recipe-sort" label="">
          <label>Sort by:</label>
          <ag-select
            id="recipe-sort"
            :value="sortValue"
            :options="sortOptions"
            :allow-empty="false"
            @change="onSort"
          />
        </ag-form-group>

        <ag-form-group
          id="filter-by-category"
          label="Filter by category:"
        >
          <category-select
            id="filter-by-category"
            :value="selectedCategory"
            with-empty-selection
            @change="onCategorySelect"
          />
        </ag-form-group>

        <ag-form-group id="with-images-only" label="">
          <ag-checkbox
            id="with-images-only"
            label="Only show recipes with images"
            :checked="withImagesOnly"
            @change="onToggleImagesFilter"
          />
        </ag-form-group>

      </div>
    </div>
    <div class="overlay" @click.stop="close"></div>
  </div>
</template>

<script>
  import XIcon from "../../../components/icons/XIcon";
  import { mapState } from "vuex";
  import CategorySelect from "./CategorySelect";

  export default {
    name: "RecipesFilterPanel",
    computed: {
      ...mapState("recipes", ["count", "columns", "sort", "withImagesOnly", "filterByCategory"]),
      sortOptions() {
        const options = [];
        for (const column of this.columns) {
          options.push({
            id: `${column.field}-ASC`,
            label: `${column.label} (Ascending)`
          });
          options.push({
            id: `${column.field}-DESC`,
            label: `${column.label} (Descending)`
          });
        }
        return options;
      },
      sortValue() {
        if (!this.sort) {
          return null;
        }

        return `${this.sort.column}-${this.sort.direction}`;
      },
      selectedCategory() {
        const selectedCategory = this.filterByCategory;
        return selectedCategory ? selectedCategory.categoryKey : null;
      }
    },
    methods: {
      close() {
        this.$emit("close");
      },
      onSort(event) {
        // Pretty hacky
        const parts = event.id.split("-");

        const sort = {
          column: parts[0],
          direction: parts[1]
        }
        this.$store.dispatch(this.$action.RECIPES.SET_SORT, sort);
      },
      onToggleImagesFilter() {
        this.$store.dispatch(this.$action.RECIPES.SET_WITH_IMAGES_ONLY, !this.withImagesOnly);
      },
      onCategorySelect(category) {
        const selectedCategory = category && category.id && category.label && {
          categoryKey: category.id,
          categoryName: category.label
        }
        this.$store.dispatch(this.$action.RECIPES.SET_CATEGORY_FILTER, selectedCategory)
      }
    },
    components: {
      XIcon,
      CategorySelect
    }
  };
</script>

<style scoped lang="scss">
  .side-panel {
    position: fixed;
    z-index: 1000;
    top: 0;
    bottom: 0;
    left: -100%;
    width: 100%;
    display: flex;
    box-shadow: 0 2px 24px rgba(0, 0, 0, 0.06);

    &.active {
      left: 0;

      .panel {
        left: 0;
      }

      .overlay {
        opacity: 0.3;
      }
    }

    .panel {
      position: fixed;
      z-index: 1001;
      top: 0;
      bottom: 0;
      left: -100%;
      width: calc(100% - 30px);
      max-width: 300px;
      display: flex;
      flex-direction: column;
      background: #fff;
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.3);
      transition: $transition;

      .panel-header {
        display: flex;
        align-items: center;
        border-bottom: $border;

        h1 {
          flex-grow: 1;
          margin: 0;
          padding: 8px 8px 8px 20px;
        }

        .close {
          cursor: pointer;
          border-radius: $radius;
          padding: 6px;
          margin: 4px 8px 5px 8px;

          svg {
            fill: $color-secondary;
            display: block;
          }

          &:hover {
            background: rgba(0, 0, 0, 0.1);

            svg {
              fill: $color-primary;
            }
          }
        }
      }

      h1 {
        display: flex;
        align-items: baseline;

        span {
          color: $color-primary;
          font-size: 14px;
          opacity: 0.7;
          margin-left: 8px;
        }
      }

      .panel-content {
        padding: $gutter;
      }
    }

    .overlay {
      flex-grow: 1;
      background: black;
      opacity: 0;
      transition: all 0.4s ease-in-out;
    }
  }
</style>
